import { useState } from 'react'

import { Result, Form, Input, Button } from 'antd'

import ButtonPrimary from "components/ButtonPrimary"

import styles from './styles.module.scss'
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons'
import { discectError } from 'lib/utils' // getSuretyLogo
import api from 'lib/api'

const Receipt = () => {
  const [error, setError] = useState(null)
  const [isComplete, setIsComplete] = useState(null)

  const [form] = Form.useForm();

  const _onSaveValues = async (values) => {
    try {
      const results = await api.inventory.receiptCode(values)
      setIsComplete(() => results)
    } catch(e) {
      let error = discectError(e)
      console.log(error, error.indexOf('INVALID_RECEIPT_CODE'))
      let errorText = 'General Error'
      if (error.indexOf('INVALID_RECEIPT_CODE') >= 0) {
        errorText = 'That is an invalid Receipt Code. Please try again.'
      } else if (error.indexOf('RECEIPT_ALREADY_VERIFIED') >= 0) {
        errorText = 'This receipt has already been verified. You can begin using these powers.'
      }
      setError(errorText)
    }
  }

  return (
    <div className={styles.receipt__container}>
      <div className={styles.receipt}>
        {isComplete && (
          <Result
            status="success"
            title="Confirmed!"
            subTitle={`You have confirmed the Receipt of your Powers.  Powers from Power Pack ${isComplete.packageId} are now ready to be used. You can close this window.`}
          />
        )}
        {error && (
          <Result
            status="error"
            title="Submission Failed"
            subTitle={error}
            extra={[
              <Button onClick={() => setError(null)}>
                Go Back
              </Button>
            ]}
          ></Result>
        )}
        {(!isComplete && !error) && (
          <>
            <header>
              {/* {getSuretyLogo(report?.suretyId, report?.suretyName)} */}
              <p>To confirm the receipt of your Powers, please enter the code below, and press Submit.</p>
            </header>
            <Form
              form={form}
              name="basic"
              initialValues={{}}
              layout="vertical"
              onFinish={_onSaveValues}
            >
              <div className={styles.splitRow}>
                <Form.Item label="Receipt Code" name="receiptCode" rules={[{ required: true, message: 'Please select the Receipt Code' }]}>
                  <Input autoFocus />
                </Form.Item>
              </div>
              <div className={styles.actions}>
                <ButtonPrimary fullWidth color="navy" icon={faCheckCircle}>Save</ButtonPrimary>
              </div>
            </Form>
          </>
        )}
      </div>
      <div className={styles.poweredBy}>
        <h5 className="rad">Powered by</h5>
        <a href="https://simplybail.com" target="_blank" rel="noreferrer">
          <img src="/images/SimplyBail_logo_long.png" alt="SimplyBail" />
        </a>
      </div>
    </div>
  ) 
}

export default Receipt